import { Box, Input, Text } from '@chakra-ui/react'

/** A labelled text/date input field. */
const FormField = ({
  label,
  type,
  value,
  onChange,
  disabled = false,
}: {
  /** Field label. */
  label: string
  /** Input type. */
  type?: 'text' | 'date'
  /** Current value. */
  value: string
  /** Called with the new value. */
  onChange: (value: string) => void
  /** Disables the input (e.g. while uploading). */
  disabled?: boolean
}) => (
  <Box>
    <Text as="label" display="block" fontSize="12px" fontWeight="semibold" color="gray.700" mb="6px">
      {label}
    </Text>
    <Input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      borderRadius="8px"
      bg="white"
    />
  </Box>
)

export default FormField
